import { React } from "react";
import { Nav, NavItem, NavLink, Row, Col, Card, CardBody } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import TeacherAdmin from "../../components/Teacher/TeacherAdmin";
import PacmanLoader from "../../components/Pacmanloader/Pacmanloader";
import DataLoadError from "../../components/DataLoadError/DataLoadError";
import {
  GetTeacherInfoById,
  GetTeacherInformation,
} from "../../actions/teacherQueries";
import { useParams } from "react-router-dom";

export default function TeacherTeacher() {
  const { teacherId } = useParams();
  const teacherData = GetTeacherInfoById(teacherId);
  const teacherInfo = GetTeacherInformation();

  if (teacherData.isError || teacherInfo.isError) {
    return <DataLoadError />;
  }

  if (teacherData.isPending) {
    return <PacmanLoader color={"#20a8d8"} size={15} loading={true} />;
  }
  return (
    <div className="animated fadeIn">
      <Row>
        <Col lg={12}>
          <Card>
            <Nav tabs className="bg-primary">
              <NavItem>
                <NavLink className="active text-primary">
                  <FontAwesomeIcon icon="map" />
                  &nbsp; <FormattedMessage id="Admin" />
                </NavLink>
              </NavItem>
            </Nav>
            <CardBody className="responsive-card animated fadeIn">
              <TeacherAdmin
                teacherData={teacherData}
                teacherInfo={teacherInfo}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
